import { Icon, Link } from "@chakra-ui/react";
import { FiMail } from "react-icons/fi";

const EMAIL = "leocgoncalves11@gmail.com";

const EmailIcon = ({ color }: { color: string }) => {
  return (
    <Link
      href={`mailto:${EMAIL}`}
      title={`Email ${EMAIL}`}
      aria-label={`Send email to ${EMAIL}`}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      w={10}
      h={10}
      color={color}
      _hover={{ opacity: 0.8 }}
    >
      <Icon as={FiMail} fontSize="2xl" />
    </Link>
  );
};

export default EmailIcon;
